import React from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import styles from "./ModalConfirmRegisterNewValue.module.scss";

const ModalConfirmRegisterNewValue = ({
  setOverlay,
  setModalConfirmRegisterNewValue,
  isCheckedDateUpdate,
  checkHandler,
  importSerialNumber,
  setImportSerialNumber,
  importSoundcardSerial,
  setImportSoundcardSerial,
  setModalConfirmImport,
  registerNewValue,
  setSerialNumber,
  setSerialSoundcardNumber,
  previousSerialNumber,
  previousSerialSoundcardNumber,
  handleSerialNumberChange,
  isImportMode,

  // Calibration pour Bone (Conduction osseuse)
  previousCalibTonal,
  previousCalibVocal,
  setCalibTonal,
  setCalibVocal,

  // Calibration pour Headphones (Casque)
  setCalibGeneral,
  setCalibTonalLeft,
  setCalibTonalRight,
  setCalibVocalLeft,
  setCalibVocalRight,
  previousCalibGeneral,
  previousCalibTonalLeft,
  previousCalibTonalRight,
  previousCalibVocalLeft,
  previousCalibVocalRight,

  previousDateCalibration,
  setDateCalibration,
  // maj
  maj,
  setMaj,
}) => {
  const { t } = useTranslation();
  // ✅ Fonction qui met à jour les inputs de BoneCalib / HeadphonesCalib
  const handleSerialCheckboxChange = (type) => {
    if (type === "serialNumber") {
      const newImportSerial = !importSerialNumber;
      setImportSerialNumber(newImportSerial);
      handleSerialNumberChange(newImportSerial, importSoundcardSerial);
    } else if (type === "serialSoundCard") {
      const newImportSoundCard = !importSoundcardSerial;
      setImportSoundcardSerial(newImportSoundCard);
      handleSerialNumberChange(importSerialNumber, newImportSoundCard);
    }
  };

  // ✅ Fonction qui restaure les anciennes valeurs
  const handleCancel = () => {
   if(setSerialNumber) setSerialNumber(previousSerialNumber);
    if (setSerialSoundcardNumber) setSerialSoundcardNumber(previousSerialSoundcardNumber);
    if(setDateCalibration) setDateCalibration(previousDateCalibration);



    // Gestion dynamique en fonction des props présentes
    if (setCalibTonal && previousCalibTonal) setCalibTonal(previousCalibTonal);
    if (setCalibVocal && previousCalibVocal) setCalibVocal(previousCalibVocal);

    if (setCalibGeneral && previousCalibGeneral) setCalibGeneral(previousCalibGeneral);
    if (setCalibTonalLeft && previousCalibTonalLeft) setCalibTonalLeft(previousCalibTonalLeft);
    if (setCalibTonalRight && previousCalibTonalRight) setCalibTonalRight(previousCalibTonalRight);
    if (setCalibVocalLeft && previousCalibVocalLeft) setCalibVocalLeft(previousCalibVocalLeft);
    if (setCalibVocalRight && previousCalibVocalRight) setCalibVocalRight(previousCalibVocalRight);

    // Fermer la modale
    setOverlay(false);
    setModalConfirmRegisterNewValue(false);
    setModalConfirmImport(false);
    setMaj(!maj)
  };

  return (
    <>
      <div
        className={styles.wrapperModal}
        onClick={handleCancel}
      />
      <div className={styles.containerModal}>
        <button
          className={`${styles.closeBtn} has-tooltip`}
          onClick={handleCancel}
          aria-label={t("common.close")}
        >
          <AiOutlineClose />
        </button>

        <h4 className={styles.modalTitle}>{t("calibration_data.register_new_data_question")}</h4>

        <div className={styles.options}>
          {isImportMode && (
            <>
              <label className={styles.checkRow}>
                <input
                  type="checkbox"
                  checked={importSerialNumber}
                  onChange={() => handleSerialCheckboxChange("serialNumber")}
                />
                {t("calibration_data.transducer_serial_number")}
              </label>
              <label className={styles.checkRow}>
                <input
                  type="checkbox"
                  checked={importSoundcardSerial}
                  onChange={() => handleSerialCheckboxChange("serialSoundCard")}
                />
                {t("calibration_data.soundcard_serial_number")}
              </label>
            </>
          )}
          <label className={styles.checkRow}>
            <input
              type="checkbox"
              checked={isCheckedDateUpdate}
              onChange={checkHandler}
            />
            {t("calibration_data.update_with_today")}
          </label>
        </div>

        <div className={styles.actions}>
          <button className={styles.btnCancel} onClick={handleCancel}>{t("common.cancel")}</button>
          <button className={styles.btnConfirm} onClick={registerNewValue}>{t("common.register")}</button>
        </div>
      </div>
    </>
  );
};

export default ModalConfirmRegisterNewValue;
